const getItemParams = (name, prefix) => {
  return {name: `${prefix}.${name}.name`, description: `${prefix}.${name}.descr`, label: `${prefix}.${name}.label`}
}

export {getItemParams};